enum ProgramSummaryRoutes {
  List = '/program-summary',
  Edit = '/program-summary/:id',
}

export default ProgramSummaryRoutes
